import { render } from "./settingsIcon.vue?vue&type=template&id=c7d42548&scoped=true"
import script from "./settingsIcon.vue?vue&type=script&lang=js"
export * from "./settingsIcon.vue?vue&type=script&lang=js"

import "./settingsIcon.vue?vue&type=style&index=0&id=c7d42548&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7d42548"]])

export default __exports__